import {
    GlobalMediaValueInputColumn,
    MediaValueInputColumn,
    SupportedCountry as GmvSupportedCountry
} from '~/graphql-react-query/graphql';
import {AU, SupportedCountry} from 'bigdatr-style';

export const GLOBAL_MEDIA_VALUE_COLUMNS = [
    'adType',
    'brand',
    'category',
//    'fuelType', // disabled until the rest of the client changes are ready
    'industry',
    'mediaType',
    'product',
    'publication',
    'region'
] as const;

export const AU_MEDIA_VALUE_COLUMNS = [
    'adType',
    'brand',
    'campaign',
    'category',
    'fuelType',
    'industry',
    'mediaOwner',
    'mediaType',
    'product',
    'publication',
    'publisher',
    'region',
    'segment'
] as const satisfies readonly MediaValueInputColumn[];

export function toGmvCountry(country: SupportedCountry): GmvSupportedCountry {
    return country === AU ? 'AU' : 'NZ';
}

export function ensureColumnsAreGmvColumns(
    maybeAustralianMvColumns: string[] | null | undefined
): GlobalMediaValueInputColumn[] {
    // i have to do this acrobatics because `MediaValueInputColumn` is a
    // superset of `GlobalMediaValueInputColumn`, so doing something like
    // `GLOBAL_MEDIA_VALUE_COLUMNS.includes(column)` doesn't make typescript
    // happy
    return (maybeAustralianMvColumns || []).flatMap((column) => {
        const found = GLOBAL_MEDIA_VALUE_COLUMNS.find((c) => c === column);
        if (found) return [found];
        return [];
    });
}

/** Narrow FilterSelect's FilterColumnV2[] down to AU MediaValueInputColumn[]. */
export function ensureColumnsAreMediaValueColumns(
    columns: string[] | null | undefined
): MediaValueInputColumn[] {
    return (columns || []).flatMap((column) => {
        const found = AU_MEDIA_VALUE_COLUMNS.find((c) => c === column);
        if (found) return [found];
        return [];
    });
}
